import { CurrencyIcon } from '@components'
import cn from '@integrations/classnames'
import { uiSize } from '@utils'
import styles from '../AccountCreateModal.module.scss'

interface Props {
  currency: string
  label: string
}

function Label({ currency, label }: Props) {
  return (
    <div className={cn(styles['account-create-label'], 'account-create-label')}>
      <CurrencyIcon currency={currency} size={uiSize(26)} />
      <span>{label}</span>
    </div>
  )
}

export default Label
